import { EventBusService, EventType, ATMEventData } from "../services/eventbus.service";
import { Observable, fromEvent } from "rxjs";
import { Injectable } from "@angular/core";
import { SubSystem } from "../models/subsystem.enum";


@Injectable()
export class SystemStatusService {
    private systemStatus: boolean = true;
    private subSystemStatus: {[key: string]: boolean} = {};

    constructor(private eventBus: EventBusService) {
        this.subscribeAndFireConnectionEvents();
        this.registerForEvents();
    }

    private subscribeAndFireConnectionEvents(): void {

        fromEvent(window, 'online')
        .subscribe(e => this.eventBus.fireEvent(EventType.ONLINE_EVENT, new ATMEventData(null, () => '')));

        fromEvent(window, 'offline')
        .subscribe(e => this.eventBus.fireEvent(EventType.OFFLINE_EVENT, new ATMEventData(null, () => '')));
    }

    private registerForEvents(): void {
        this.eventBus.getEventBus(EventType.SET_OUTAGE_EVENT)
            .subscribe(eventData  => this.updateSystemState(SubSystem.OUTAGE, false));
        this.eventBus.getEventBus(EventType.CLEAR_OUTAGE_EVENT)
            .subscribe(eventData  => this.updateSystemState(SubSystem.OUTAGE, true));
        this.eventBus.getEventBus(EventType.ONLINE_EVENT)
            .subscribe(eventData  => this.updateSystemState(SubSystem.CONNECTION, true));
        this.eventBus.getEventBus(EventType.OFFLINE_EVENT)
            .subscribe(eventData  => this.updateSystemState(SubSystem.CONNECTION, false));
    }

    private updateSystemState(subSystem: SubSystem, subSystemState: boolean) {
        if (subSystem === SubSystem.CONNECTION) {
            // CSXMobile.online = subSystemState;
        }
        let status: boolean = true;
        this.subSystemStatus[subSystem] = subSystemState;

        for (let key in this.subSystemStatus) {
            status = status && this.subSystemStatus[key];
        }

        if (status !== this.systemStatus) {
            this.systemStatus = status;
            this.publish(this.systemStatus);
        }
    }

    public updateEvent(){
        this.eventBus.fireEvent(EventType.ONLINE_EVENT, new ATMEventData(null, () => ''));

    }
    private publish(systemStauts: boolean) {
        if (systemStauts) {
            this.eventBus.fireEvent(EventType.SYSTEM_ENABLED_EVENT
                , new ATMEventData('System is Enabled', () => ''));
        } else {
            this.eventBus.fireEvent(EventType.SYSTEM_DISABLED_EVENT
                , new ATMEventData('The application is experiencing an outage. Please contact the dispatcher.', () => ''));
        }
    }

    public get state(): boolean {
        return this.systemStatus;
    }
}